// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nuWf","colBig":"styles_colBig__KvRnF","colSmall":"styles_colSmall__2wsXo"};